import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AffiliateDashboardView from '../components/AffiliateDashboardView';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Legacy read-only link (?token= from before login existed). Kept working
// alongside /affiliate/login so a link already handed out never breaks —
// see AffiliateDashboard.jsx for the logged-in, self-serve equivalent.
export default function AffiliatePortal() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/affiliates/portal?token=${encodeURIComponent(token)}`);
        if (!res.ok) throw new Error(res.status === 404 ? 'This affiliate link is not valid.' : 'Could not load your dashboard.');
        setData(await res.json());
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading your dashboard...</div>;
  if (error) return <div className="min-h-screen flex items-center justify-center text-gray-600">{error}</div>;

  return <AffiliateDashboardView data={data} editable={false} />;
}
